var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_8602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.7575 0 7.685 1.68675 4.6875 4.68625C1.68691 7.68694 0.000831175 11.7565 0 16C0 20.2417 1.6875 24.3142 4.6875 27.3137C7.685 30.3132 11.7575 32 16 32C20.2425 32 24.315 30.3132 27.3125 27.3137C30.3125 24.3142 32 20.2417 32 16C32 11.7583 30.3125 7.68575 27.3125 4.68625C24.315 1.68675 20.2425 0 16 0Z",
    fill: "url(#paint0_linear_616_8602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24262 15.831C11.9076 13.799 15.0176 12.4592 16.5726 11.812C21.0176 9.96374 21.9401 9.64274 22.5426 9.63187C22.6751 9.62974 22.9701 9.66249 23.1626 9.81812C23.3226 9.94937 23.3676 10.1269 23.3901 10.2515C23.4101 10.376 23.4376 10.6597 23.4151 10.8812C23.1751 13.4112 22.1326 19.5507 21.6026 22.3845C21.3801 23.5835 20.9376 23.9855 20.5101 24.0247C19.5801 24.1102 18.8751 23.4107 17.9751 22.821C16.5676 21.8977 15.7726 21.3232 14.4051 20.4225C12.8251 19.3815 13.8501 18.8092 14.7501 17.8742C14.9851 17.6295 19.0801 13.9057 19.1576 13.568C19.1676 13.5257 19.1776 13.3682 19.0826 13.2852C18.9901 13.202 18.8526 13.2305 18.7526 13.253C18.6101 13.285 16.3626 14.772 12.0026 17.7137C11.3651 18.1522 10.7876 18.366 10.2676 18.3547C9.69762 18.3425 8.59762 18.0317 7.78012 17.7662C6.78012 17.4405 5.98262 17.2682 6.05262 16.715C6.08762 16.427 6.48512 16.1322 7.24262 15.831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_616_8602",
    x1: 1600,
    y1: 0,
    x2: 1600,
    y2: 3200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_8602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.09451b68d48a96b4dde5166aaa749a05.svg";
export { ForwardRef as ReactComponent };